import assert from "node:assert/strict";
import { execFile } from "node:child_process";
import { cp, mkdir, mkdtemp, rm, symlink, writeFile } from "node:fs/promises";
import { tmpdir } from "node:os";
import path from "node:path";
import { it } from "node:test";
import { fileURLToPath, pathToFileURL } from "node:url";
import { promisify } from "node:util";

it("loads the compiled catalog from an isolated published-package layout", async () => {
  const root = await mkdtemp(path.join(tmpdir(), "gateway-package-"));
  try {
    const directory = path.join(root, "dist/source/ai-gateway");
    await mkdir(directory, { recursive: true });
    for (const name of ["planner.js", "catalog.json"])
      await cp(new URL(name, import.meta.url), path.join(directory, name));
    await writeFile(path.join(root, "package.json"), '{"type":"module"}');
    await symlink(
      fileURLToPath(new URL("../../../../../node_modules", import.meta.url)),
      path.join(root, "node_modules"),
      "dir"
    );
    const script = `const { catalog, planUpgrade } = await import(${JSON.stringify(pathToFileURL(path.join(directory, "planner.js")).href)}); const plan = planUpgrade(catalog.snapshots[1].files, "1.0.0"); if (plan.blockers.length || !plan.additions.length) process.exit(1);`;
    const result = await promisify(execFile)(process.execPath, [
      "--input-type=module",
      "-e",
      script,
    ]);
    assert.equal(result.stderr, "");
  } finally {
    await rm(root, { recursive: true, force: true });
  }
});
